import classNames from 'classnames';

import { MirrorService } from 'services/MirrorService';
import { AppDomain } from 'types/enums/AppDomain';

export const getThemeClassNames = (
  defaultClassName: string,
  themeClassNames: Record<string, string>
) => {
  return classNames(defaultClassName, themeClassNames[MirrorService.domain]);
};

export const MIRRORS_THEMES: Partial<Record<AppDomain, Record<string, any>>> = {
  [AppDomain.Hookupers]: {
    primary: '#212121',
    accent: '#de2600',
    black: '#212121',
    'accent-light': '#de26001a',
    'primary-text-color': '#212121',
  },

  [AppDomain.BestHookuper]: {
    primary: '#212121',
    accent: '#de2600',
    black: '#212121',
    'accent-light': '#de26001a',
    'primary-text-color': '#212121',
  },

  [AppDomain.HookupParadise]: {
    primary: '#212121',
    accent: '#de2600',
    black: '#212121',
    'accent-light': '#de26001a',
    'primary-text-color': '#212121',
  },

  [AppDomain.DatesMe]: {
    primary: '#212121',
    accent: '#de2600',
    black: '#212121',
    'accent-light': '#de26001a',
    'primary-text-color': '#212121',
  },

  [AppDomain.MePlusYou]: {
    primary: '#6C2FE7',
    accent: '#FF67B0',
    black: '#212121',
    'accent-light': '#ff67b01a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Meamo]: {
    primary: '#F1C154',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Matchess]: {
    primary: '#2D3C6C',
    accent: '#F06B05',
    black: '#212121',
    'accent-light': '#f06b051a',

    'primary-text-color': '#212121',
  },

  [AppDomain.Uniteus]: {
    primary: '#CB996D',
    accent: '#D3171F',
    black: '#212121',
    'accent-light': '#d3171f1a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Ppl2ppl]: {
    primary: '#D47682',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Theunite]: {
    primary: '#253954',
    accent: '#F1914C',
    black: '#212121',
    'accent-light': '#f1914c1a',
    'primary-text-color': '#212121',
  },

  [AppDomain.FinderSingles]: {
    primary: '#182B46',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.JoyFinder]: {
    primary: '#B80208',
    accent: '#FCB389',
    black: '#212121',
    'accent-light': '#fcb3891a',
    'primary-text-color': '#212121',
  },

  [AppDomain.FlirtGuru]: {
    primary: '#C2CB8A',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.FlirtDiscovery]: {
    primary: '#538096',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.AdventureRelation]: {
    primary: '#000000',
    accent: '#FFC700',
    black: '#212121',
    'accent-light': '#ffc7001a',
    'primary-text-color': '#212121',
  },

  [AppDomain.LocalsDate]: {
    primary: '#2C3983',
    accent: '#49E3A0',
    black: '#212121',
    'accent-light': '#49e3a01a',
    'primary-text-color': '#212121',
  },

  [AppDomain.LustStation]: {
    primary: '#2C3983',
    accent: '#49E3A0',
    black: '#212121',
    'accent-light': '#49e3a01a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Localsjoy]: {
    primary: '#6C2FE7',
    accent: '#FF67B0',
    black: '#212121',
    'accent-light': '#ff67b01a',
    'primary-text-color': '#212121',
  },
  [AppDomain.DreamsDate]: {
    primary: '#CC2B33',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.NeverAlones]: {
    primary: '#DF9240',
    accent: '#A06423',
    black: '#212121',
    'accent-light': '#a064231a',
    'primary-text-color': '#212121',
  },

  [AppDomain.DateaSoul]: {
    primary: '#F2BD40',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.DateaSoulmate]: {
    primary: '#DF3232',
    accent: '#FFB78F',
    black: '#212121',
    'accent-light': '#ffb78f1a',
    'primary-text-color': '#212121',
  },

  [AppDomain.YourLove4Life]: {
    primary: '#F18CA3',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.RelationshipNest]: {
    primary: '#F18CA3',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.CupidKeys]: {
    primary: '#253954',
    accent: '#F1914C',
    black: '#212121',
    'accent-light': '#f1914c1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.AmourPulse]: {
    primary: '#74A0A9',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.MyConnectly]: {
    primary: '#CB996D',
    accent: '#D3171F',
    black: '#212121',
    'accent-light': '#d3171f1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.TenderTalkers]: {
    primary: '#F2BD40',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Tiamo]: {
    primary: '#D50A38',
    accent: '#000000',
    black: '#212121',
    'accent-light': '#0000001a',
    'primary-text-color': '#212121',
  },

  [AppDomain.SimpleDatesMe]: {
    primary: '#6667AB',
    accent: '#6667AB',
    black: '#212121',
    'accent-light': '#6667ab1a',
    'primary-text-color': '#212121',
  },

  [AppDomain.SweatHeartSoul]: {
    primary: '#F1C154',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Linkamora]: {
    primary: '#2D3C6C',
    accent: '#F06B05',
    black: '#212121',
    'accent-light': '#f06b051a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Flirtiveo]: {
    primary: '#CB996D',
    accent: '#D3171F',
    black: '#212121',
    'accent-light': '#d3171f1a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Tendrilink]: {
    primary: '#D47682',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.Chateluna]: {
    primary: '#253954',
    accent: '#F1914C',
    black: '#212121',
    'accent-light': '#f1914c1a',
    'primary-text-color': '#212121',
  },

  [AppDomain.GetParamour]: {
    primary: '#D47682',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.TripToLove]: {
    primary: '#74A0A9',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },

  [AppDomain.SimpleDatesCo]: {
    primary: '#6667AB',
    accent: '#6667AB',
    black: '#212121',
    'accent-light': '#6667ab1a',
    'primary-text-color': '#212121',
  },

  // * DESCRIPTORS THEMES START
  [AppDomain.PaysPlay]: {
    primary: '#F5CC71',
    accent: '#F5CC71',
    black: '#212121',
    'accent-light': '#F5CC711a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Bst4flPay]: {
    primary: '#82CAFF',
    accent: '#82CAFF',
    black: '#212121',
    'accent-light': '#82CAFF1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.ArmBills]: {
    primary: '#14D3C8',
    accent: '#14D3C8',
    black: '#212121',
    'accent-light': '#14D3C81a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Armor2Pay]: {
    primary: '#FA9898',
    accent: '#FA9898',
    black: '#212121',
    'accent-light': '#FA98981a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Bill4Info]: {
    primary: '#DBF571',
    accent: '#DBF571',
    black: '#212121',
    'accent-light': '#DBF5711a',
    'primary-text-color': '#212121',
  },
  [AppDomain.BillingAct]: {
    primary: '#FFC4A7',
    accent: '#FFC4A7',
    black: '#212121',
    'accent-light': '#FFC4A71a',
    'primary-text-color': '#212121',
  },
  [AppDomain.BillNow24]: {
    primary: '#81D1FF',
    accent: '#81D1FF',
    black: '#212121',
    'accent-light': '#81D1FF1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Charge2Rock]: {
    primary: '#9B71F5',
    accent: '#9B71F5',
    black: '#212121',
    'accent-light': '#9B71F51a',
    'primary-text-color': '#212121',
  },
  [AppDomain.ChecksPay]: {
    primary: '#DBDBDB',
    accent: '#DBDBDB',
    black: '#212121',
    'accent-light': '#DBDBDB1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.HelpInBill]: {
    primary: '#7F79A4',
    accent: '#7F79A4',
    black: '#212121',
    'accent-light': '#7F79A41a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Hub4Bill]: {
    primary: '#97AEFF',
    accent: '#97AEFF',
    black: '#212121',
    'accent-light': '#97AEFF1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Paid4Act]: {
    primary: '#FF9292',
    accent: '#FF9292',
    black: '#212121',
    'accent-light': '#FF92921a',
    'primary-text-color': '#212121',
  },
  [AppDomain.PaiFastly]: {
    primary: '#B4E48E',
    accent: '#B4E48E',
    black: '#212121',
    'accent-light': '#B4E48E1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Pay2Connect]: {
    primary: '#EE8989',
    accent: '#EE8989',
    black: '#212121',
    'accent-light': '#EE89891a',
    'primary-text-color': '#212121',
  },
  [AppDomain.PayInSec]: {
    primary: '#71C5F5',
    accent: '#71C5F5',
    black: '#212121',
    'accent-light': '#71C5F51a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Payment2Rock]: {
    primary: '#F5CC71',
    accent: '#F5CC71',
    black: '#212121',
    'accent-light': '#F5CC711a',
    'primary-text-color': '#212121',
  },
  [AppDomain.FlrtPay]: {
    primary: '#E1A6FD',
    accent: '#E1A6FD',
    black: '#212121',
    'accent-light': '#E1A6FD1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.BillTime24]: {
    primary: '#F57171',
    accent: '#F57171',
    black: '#212121',
    'accent-light': '#F571711a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Debit2Pay]: {
    primary: '#BEE79F',
    accent: '#BEE79F',
    black: '#212121',
    'accent-light': '#BEE79F1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Info_Pay24]: {
    primary: '#F5CC71',
    accent: '#F5CC71',
    black: '#212121',
    'accent-light': '#F5CC71a',
    'primary-text-color': '#212121',
  },
  [AppDomain.InfoPay24]: {
    primary: '#82CAFF',
    accent: '#82CAFF',
    black: '#212121',
    'accent-light': '#82CAFFa',
    'primary-text-color': '#212121',
  },
  [AppDomain.PaymentInfo24]: {
    primary: '#B3A6B4',
    accent: '#B3A6B4',
    black: '#212121',
    'accent-light': '#B3A6B4a',
    'primary-text-color': '#212121',
  },
  [AppDomain.BillInfo24]: {
    primary: '#D1EBEA',
    accent: '#D1EBEA',
    black: '#212121',
    'accent-light': '#D1EBEAa',
    'primary-text-color': '#212121',
  },
  [AppDomain.ChPay24]: {
    primary: '#707078',
    accent: '#707078',
    black: '#212121',
    'accent-light': '#707078a',
    'primary-text-color': '#212121',
  },
  [AppDomain.BestBill]: {
    primary: '#FFC4A7',
    accent: '#FFC4A7',
    black: '#212121',
    'accent-light': '#FFC4A7a',
    'primary-text-color': '#212121',
  },
  [AppDomain.BestBill24]: {
    primary: '#A0DDFF',
    accent: '#A0DDFF',
    black: '#212121',
    'accent-light': '#A0DDFFa',
    'primary-text-color': '#212121',
  },
  [AppDomain.BestPay24]: {
    primary: '#EDD1C2',
    accent: '#EDD1C2',
    black: '#212121',
    'accent-light': '#EDD1C2a',
    'primary-text-color': '#212121',
  },

  [AppDomain.DrmsPay]: {
    primary: '#BEE79F',
    accent: '#BEE79F',
    black: '#212121',
    'accent-light': '#BEE79Fa',
    'primary-text-color': '#212121',
  },
  [AppDomain.BvlntnPay]: {
    primary: '#EDD1C2',
    accent: '#EDD1C2',
    black: '#212121',
    'accent-light': '#EDD1C2a',
    'primary-text-color': '#212121',
  },
  [AppDomain.PplPay]: {
    primary: '#B3A6B4',
    accent: '#B3A6B4',
    black: '#212121',
    'accent-light': '#B3A6B4a',
    'primary-text-color': '#212121',
  },
  [AppDomain.DtngPay]: {
    primary: '#82CAFF',
    accent: '#82CAFF',
    black: '#212121',
    'accent-light': '#82CAFFa',
    'primary-text-color': '#212121',
  },
  [AppDomain.LklBill]: {
    primary: '#9494FF',
    accent: '#9494FF',
    black: '#212121',
    'accent-light': '#9494FFa',
    'primary-text-color': '#212121',
  },
  [AppDomain.BstfrflrtPay]: {
    primary: '#FFC4A7',
    accent: '#FFC4A7',
    black: '#212121',
    'accent-light': '#FFC4A7a',
    'primary-text-color': '#212121',
  },
  [AppDomain.JfndrPay]: {
    primary: '#A0DDFF',
    accent: '#A0DDFF',
    black: '#212121',
    'accent-light': '#A0DDFFa',
    'primary-text-color': '#212121',
  },
  [AppDomain.LvpthPay]: {
    primary: '#14D3C8',
    accent: '#14D3C8',
    black: '#212121',
    'accent-light': '#14D3C8a',
    'primary-text-color': '#212121',
  },
  [AppDomain.TndPay]: {
    primary: '#14D3C8',
    accent: '#14D3C8',
    black: '#212121',
    'accent-light': '#14D3C8a',
    'primary-text-color': '#212121',
  },
  [AppDomain.APay24]: {
    primary: '#FA9898',
    accent: '#FA9898',
    black: '#212121',
    'accent-light': '#FA98981a',
    'primary-text-color': '#212121',
  },
  [AppDomain.NstPay24]: {
    primary: '#7F79A4',
    accent: '#7F79A4',
    black: '#212121',
    'accent-light': '#7F79A41a',
    'primary-text-color': '#212121',
  },
  [AppDomain.ConnectPay24]: {
    primary: '#A0DDFF',
    accent: '#A0DDFF',
    black: '#212121',
    'accent-light': '#A0DDFFa',
    'primary-text-color': '#212121',
  },
  // * DESCRIPTORS THEMES END

  [AppDomain.LookLie]: {
    primary: '#8BDBE2',
    accent: '#8BDBE2',
    black: '#212121',
    'accent-light': '#8BDBE21a',
    'primary-text-color': '#212121',
  },
  [AppDomain.SupremeDate]: {
    primary: '#FF3CA0',
    accent: '#FF3CA0',
    black: '#212121',
    'accent-light': '#FF3CA01a',
    'primary-text-color': '#212121',
  },
  [AppDomain.TheCupies]: {
    primary: '#F2BD40',
    accent: '#F2BD40',
    black: '#212121',
    'accent-light': '#F2BD401a',
    'primary-text-color': '#212121',
  },
  [AppDomain.PerfectDatings]: {
    primary: '#D48334',
    accent: '#D48334',
    black: '#212121',
    'accent-light': '#D483341a',
    'primary-text-color': '#212121',
  },
  [AppDomain.DatingForLife]: {
    primary: '#9B73F0',
    accent: '#9B73F0',
    black: '#212121',
    'accent-light': '#9B73F01a',
    'primary-text-color': '#212121',
  },
  [AppDomain.ForeverLover]: {
    primary: '#99F240',
    accent: '#99F240',
    black: '#212121',
    'accent-light': '#99F2401a',
    'primary-text-color': '#212121',
  },
  [AppDomain.FlirtingLover]: {
    primary: '#F2BD40',
    accent: '#F2BD40',
    black: '#212121',
    'accent-light': '#F2BD401a',
    'primary-text-color': '#212121',
  },
  [AppDomain.DatingsLover]: {
    primary: '#EFCBB9',
    accent: '#EFCBB9',
    black: '#212121',
    'accent-light': '#EFCBB91a',
    'primary-text-color': '#212121',
  },
  [AppDomain.BeValentine]: {
    primary: '#D97D41',
    accent: '#D97D41',
    black: '#212121',
    'accent-light': '#D97D411a',
    'primary-text-color': '#212121',
  },
  [AppDomain.OnesValentine]: {
    primary: '#F2BD40',
    accent: '#F2BD40',
    black: '#212121',
    'accent-light': '#F2BD401a',
    'primary-text-color': '#212121',
  },
  [AppDomain.DayDreamme]: {
    primary: '#2BB9B9',
    accent: '#2BB9B9',
    black: '#212121',
    'accent-light': '#2BB9B91a',
    'primary-text-color': '#212121',
  },
  [AppDomain.DayDreamsDate]: {
    primary: '#9BE765',
    accent: '#9BE765',
    black: '#212121',
    'accent-light': '#9BE7651a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Delightedus]: {
    primary: '#87C6EA',
    accent: '#87C6EA',
    black: '#212121',
    'accent-light': '#87C6EA1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.BestForFlirt]: {
    primary: '#F57070',
    accent: '#F57070',
    black: '#212121',
    'accent-light': '#F570701a',
    'primary-text-color': '#212121',
  },
  [AppDomain.PerfectFlirt]: {
    primary: '#ABC8DA',
    accent: '#ABC8DA',
    black: '#212121',
    'accent-light': '#ABC8DA1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.MeetLie]: {
    primary: '#FFCC48',
    accent: '#FFCC48',
    black: '#212121',
    'accent-light': '#FFCC481a',
    'primary-text-color': '#212121',
  },
  [AppDomain.KlubMe]: {
    primary: '#FFCEA2',
    accent: '#FFCEA2',
    black: '#212121',
    'accent-light': '#FFCEA21a',
    'primary-text-color': '#212121',
  },
  [AppDomain.Ppls]: {
    primary: '#E19A4C',
    accent: '#E19A4C',
    black: '#212121',
    'accent-light': '#E19A4C1a',
    'primary-text-coloDatingForLifer': '#212121',
  },
  [AppDomain.Hitchii]: {
    primary: '#3DC192',
    accent: '#3DC192',
    black: '#212121',
    'accent-light': '#3DC1921a',
    'primary-text-color': '#212121',
  },
  [AppDomain.SociableSpots]: {
    primary: '#F18CA3',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.MeetNests]: {
    primary: '#253954',
    accent: '#F1914C',
    black: '#212121',
    'accent-light': '#f1914c1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.PeopleMeetClub]: {
    primary: '#74A0A9',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.GotLinkedNow]: {
    primary: '#CB996D',
    accent: '#D3171F',
    black: '#212121',
    'accent-light': '#d3171f1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.MeetHarbor]: {
    primary: '#F2BD40',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.RelationTunes]: {
    primary: '#F18CA3',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.DateMateHub]: {
    primary: '#253954',
    accent: '#F1914C',
    black: '#212121',
    'accent-light': '#f1914c1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.LinkupNook]: {
    primary: '#74A0A9',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.TheLinkupers]: {
    primary: '#CB996D',
    accent: '#D3171F',
    black: '#212121',
    'accent-light': '#d3171f1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.SoulMatesLab]: {
    primary: '#F2BD40',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.FairyDates]: {
    primary: '#D48334',
    accent: '#D48334',
    black: '#212121',
    'accent-light': '#D483341a',
    'primary-text-color': '#212121',
  },
  [AppDomain.WaitForMe]: {
    primary: '#9B73F0',
    accent: '#9B73F0',
    black: '#212121',
    'accent-light': '#9B73F01a',
    'primary-text-color': '#212121',
  },
  [AppDomain.LookFor4you]: {
    primary: '#87C6EA',
    accent: '#87C6EA',
    black: '#212121',
    'accent-light': '#87C6EA1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.TheManWoman]: {
    primary: '#FFCC48',
    accent: '#FFCC48',
    black: '#212121',
    'accent-light': '#FFCC481a',
    'primary-text-color': '#212121',
  },
  [AppDomain.UsTogether]: {
    primary: '#99F240',
    accent: '#99F240',
    black: '#212121',
    'accent-light': '#99F2401a',
    'primary-text-color': '#212121',
  },
  [AppDomain.AmorPassion]: {
    primary: '#F18CA3',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.AmoreAffair]: {
    primary: '#253954',
    accent: '#F1914C',
    black: '#212121',
    'accent-light': '#f1914c1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.AmoreLover]: {
    primary: '#74A0A9',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.AmorFlames]: {
    primary: '#CB996D',
    accent: '#D3171F',
    black: '#212121',
    'accent-light': '#d3171f1a',
    'primary-text-color': '#212121',
  },
  [AppDomain.AmoreDesire]: {
    primary: '#F2BD40',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.JustLovebirds]: {
    primary: '#F1C154',
    accent: '#F16212',
    black: '#212121',
    'accent-light': '#f162121a',
    'primary-text-color': '#212121',
  },
  [AppDomain.AdventureDate]: {
    primary: '#EFCBB9',
    accent: '#EFCBB9',
    black: '#212121',
    'accent-light': '#EFCBB91a',
    'primary-text-color': '#212121',
  },
};
